import { formatPrice } from "../utils/formatPrice";
import { formatHotelIlsRoundedDisplay } from "../utils/formatHotelIlsRoundedDisplay";
/**
 * Hotel search request currency (searchHotels / searchHotelsComposite).
 * Extend HOTEL_SEARCH_CURRENCIES to add EUR, GBP, AED, etc.
 */

export const HOTEL_SEARCH_CURRENCY_STORAGE_KEY = "selectedHotelSearchCurrency";

/** @type {{ code: string, label: string, symbol: string }[]} */
export const HOTEL_SEARCH_CURRENCIES = [
  { code: "USD", label: "USD", symbol: "$" },
  { code: "ILS", label: "ILS", symbol: "₪" },
];

export const DEFAULT_HOTEL_SEARCH_CURRENCY = HOTEL_SEARCH_CURRENCIES[0].code;

const CODE_SET = new Set(HOTEL_SEARCH_CURRENCIES.map((c) => c.code));

/**
 * @param {string|null|undefined} code
 * @returns {string}
 */
export function normalizeHotelSearchCurrencyCode(code) {
  const c = String(code ?? "")
    .trim()
    .toUpperCase();
  return CODE_SET.has(c) ? c : DEFAULT_HOTEL_SEARCH_CURRENCY;
}

/**
 * @param {string|null|undefined} code
 * @returns {{ code: string, label: string, symbol: string }}
 */
export function getHotelSearchCurrencyMeta(code) {
  const normalized = normalizeHotelSearchCurrencyCode(code);
  return (
    HOTEL_SEARCH_CURRENCIES.find((x) => x.code === normalized) ??
    HOTEL_SEARCH_CURRENCIES[0]
  );
}

/** @param {string|null|undefined} code */
export function isKnownHotelSearchCurrencyCode(code) {
  const c = String(code ?? "")
    .trim()
    .toUpperCase();
  return CODE_SET.has(c);
}

/**
 * מטא-דאטה רק לקוד שמופיע ברשימת המטבעות הנתמכים — ללא ברירת מחדל ל-USD.
 * @param {string|null|undefined} code
 * @returns {{ code: string, label: string, symbol: string }|null}
 */
export function getHotelSearchCurrencyMetaIfKnown(code) {
  const c = String(code ?? "")
    .trim()
    .toUpperCase();
  if (!CODE_SET.has(c)) return null;
  return HOTEL_SEARCH_CURRENCIES.find((x) => x.code === c) ?? null;
}

/**
 * מספר ממוספר + סימבול רק לקודים ברשימת המלון (USD/ILS); אחרת מספר בלבד (בלי ניחוש מטבע).
 * @param {number|null|undefined} value
 * @param {string|null|undefined} currencyCode
 * @returns {string|null}
 */
export function formatHotelSearchAmountForDisplay(value, currencyCode) {
  if (value == null || !Number.isFinite(Number(value))) return null;
  const n = Number(value);
  const meta = getHotelSearchCurrencyMetaIfKnown(currencyCode);
  const code = meta?.code || normalizeHotelSearchCurrencyCode(currencyCode);
  if (code === "ILS") {
    return formatHotelIlsRoundedDisplay(n);
  }
  return formatPrice(n, code);
}
